// ——— 权限工具（只读 / 可写判断）———
//
// 约定：
//   系统管理员（menu_perm === null）        → 不受按钮权限限制
//   非系统管理员，btn_perm 未配置(null)      → 该角色未启用按钮级限制，可写
//   非系统管理员，btn_perm 非空数组          → 可写（'*' 表示全部写操作）
//   非系统管理员，btn_perm 显式为空数组      → 仅查看，写操作一律禁用

// 当前登录账号是否具备写操作权限
export function canWrite() {
  try {
    const raw = localStorage.getItem('profile')
    if (!raw) return false
    const profile = JSON.parse(raw)
    // 系统管理员不受按钮权限限制
    if (profile.menu_perm === null) return true
    const btnPerm = profile.btn_perm
    // 未配置按钮权限（null/undefined）= 未启用按钮级限制，按菜单权限放行
    if (btnPerm === null || btnPerm === undefined) return true
    return Array.isArray(btnPerm) && btnPerm.length > 0
  } catch (e) {
    // profile 缺失或解析失败时按只读处理
    return false
  }
}

// 判定按钮文本是否为写操作（用于对未显式声明权限的按钮做兜底置灰/拦截）
//
// 策略：先放行明确的只读操作（查看/详情/预览/打印/导出/下载），
// 再正向匹配写操作词；识别不出的按钮一律放行。
// 这样可以避免误伤只读按钮，而漏判的写操作仍由后端权限校验兜底，不会越权。
export function isWriteActionText(text) {
  if (!text) return false  // 无文本（纯图标按钮）无法判定，放行
  // 只读类操作优先放行（如"查看阶段""导出对账单"）
  if (/查看|详情|预览|打印|导出|下载/.test(text)) return false
  return /新建|新增|添加|创建|录入|编辑|修改|删除|删|移除|提交|送审|审核|审批|通过|驳回|拒绝|作废|出库|入库|发货|取货|送货|确认|保存|暂存|导入|生成|转换|指派|指定|分配|撤销|撤回|重命名|追加|下达|调整|处理|同步|锁定|解锁|归档|结算|过账|释放|启用|停用|阶段|选择文件|上传/.test(text)
}

// 只读账号触发写操作时的统一提示
export const READONLY_TIP = '当前账号仅有查看权限'

// 豁免路由：个人设置允许修改本人账号信息，不做只读限制
export const READONLY_BYPASS_PATHS = ['/system/profile', '/profile']
